import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

interface WorkCardProps {
  work: Work;
  showHeat?: boolean;
}

export default function WorkCard({ work, showHeat = false }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title}（${work.year}）海报`}
          title={`${work.title} 影视资讯 封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-foreground-950/85 to-transparent" />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[11px]" />
          {work.rating.toFixed(1)}
        </span>
        {work.type === "series" && (
          <span className="absolute right-2 top-2 rounded-md bg-primary-800/85 px-2 py-1 text-xs font-medium text-background-50">
            {work.duration}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="truncate font-heading text-base font-bold text-background-50">{work.title}</h3>
          <p className="mt-1 truncate text-xs text-background-100/80">
            {work.year} · {work.region} · {work.genres.join(" / ")}
          </p>
        </div>
      </div>
      <div className="p-3">
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{work.synopsis}</p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="truncate">导演 {work.director}</span>
          {showHeat && (
            <span className="flex items-center gap-1 whitespace-nowrap text-accent-700">
              <i className="ri-fire-line" />
              {(work.heat / 1000).toFixed(1)}k
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}